<template>
  <div class="get-coupon-container">
  <div v-if="showcouponList">
      <div class="get-coupon con"  >
      <div class="title">
        <p class="p1">好券来袭，省钱秘要</p>
        <p class="p2">COUPON</p>
        <p class="p3"></p>
        <p class="p4" @click="goto">
          <img :src="require('@/assets/images/icon_coupons.png')" alt="" />
          <span>我的优惠券</span>
        </p>
      </div>
      <div class="coupon-info" v-if="couponList.length > 0">
        <div
          class="coupon-item"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <div class="div1">
            <img
              v-if="item.type == 1"
              :src="require('@/assets/images/icon_reduction.png')"
              alt=""
            />
            <img
              v-if="item.type == 2"
              :src="require('@/assets/images/icon_discount.png')"
              alt=""
            />
            <img
              v-if="item.type == 3"
              :src="require('@/assets/images/icon_reduction.png')"
              alt=""
            />
          </div>
          <div class="div2">
            <div class="coupon-title">
              <span class="span1"
                >￥<i>{{ item.reduceAmount }}</i></span
              >
              <span class="span2">满{{ item.conditionAmount }}可用</span>
            </div>
            <div class="desc" :title="item.intro">{{ item.intro }}</div>
            <div class="date">{{ item.startDate }} - {{ item.endDate }}</div>
          </div>
          <div class="div3">
            <span class="status" v-if="item.menu == 3"
              >{{ item.typeName }}已抢光</span
            >
            <span class="status" v-if="item.menu == 4"
              >{{ item.typeName }}已过期</span
            >
            <span
              class="span1"
              v-if="item.menu == 1"
              @click="getCoupon(index, item.id)"
              >领取优惠券</span
            >
            <span v-if="item.menu == 2" class="span1">立即使用</span>
            <span v-if="item.menu == 4" class="span2">已过期</span>
            <span v-if="item.menu == 3" class="span2">已抢光</span>
          </div>
        </div>
      </div>
        <div class="empty" v-if="couponList.length == 0">
           <div class="empty-img">
             <img :src="require('@/assets/images/all_yhq.png')" alt="">
           </div>
      <div class="empty-con">
        <h5>暂无可领取的优惠券</h5>
        <p>近期暂无可领取的优惠券，请继续关注领券中心</p>
      </div>
    </div>
    </div>
  
  </div>
    <toast ref="toast"></toast>
    <success v-if="show">领取成功</success>
  </div>
</template>
<script>
import success from "@/components/success.vue";
export default {
  components: { success },
  data() {
    return {
      show: false,
      couponList: [],
      showcouponList:false
    };
  },
  computed: {},
  methods: {
    success() {
      this.show = false;
    },
    getCoupon(index,id){
      
      //console.log(id);
      //领取优惠券
      this.$api.POST_GETCOUPON({ couponId: id }).then((res) => {
        if (res.status) {
          this.show = true;
        } else {
          var title = "";
          if (!this.$store.state.hasLogin) {
            title = "请先登录";
          } else {
            title = res.message;
          }
          this.$refs.toast.info = {
            title,
            type: "fail",
          };
          this.$refs.toast.isShow();
        }
      });
    },
    goto() {
      this.$router.push({ path: "/person/coupon" });
    },
    getCouponList() {
      this.$api.POST_COUPONCENTER().then((res) => {
        if (res.status) {
          this.couponList = res.data;
          this.showcouponList = true
        }
      });
    },
  },
  created() {
    this.getCouponList();
  },
};
</script>
<style lang="scss" scoped>
.get-coupon-container {
  background-color: #fafafa;
    min-height: calc(100vh - 252px);
  .title {
    padding: 40px 0 34px 0;
    text-align: center;
    position: relative;
    .p1 {
      font-size: 28px;
      color: #333333;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .p2 {
      font-size: 12px;
      color: #cccccc;
      margin-bottom: 16px;
    }
    .p3 {
      width: 30px;
      height: 4px;
      margin: 0 auto;
      background: #fa4b4b;
    }
    .p4 {
      width: 124px;
      height: 30px;
      background: #ffffff;
      @include flex-c;
      border-radius: 15px;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 40px;
      img {
        margin-right: 6px;
      }
      span {
        font-size: 14px;
        color: #505050;
      }
    }
  }
  .coupon-info {
    overflow: hidden;
    .coupon-item:nth-child(2n) {
      margin-left: 20px;
    }
    .coupon-item {
      margin-bottom: 20px;
      float: left;
      display: flex;
      align-items: center;
      width: 590px;
      height: 180px;
      background: url("../../../assets/images/icon_coupon_bg.png") no-repeat
        100% 100%;
      position: relative;
      .div1 {
        width: 100px;
        height: 74px;
        margin: 0 32px;
      }
      .div2{
        width: 250px
      }

      .div3 {
        @include flex-d-c;
        position: absolute;
        right: 36px;
        span {
          font-size: 14px;
          display: inline-block;
          width: 98px;
          height: 36px;
          text-align: center;
          border-radius: 24px;
          line-height: 36px;
          color: #ffffff;
        }
        .span1 {
          background: #fa4b4b;
          cursor: pointer;
          box-shadow: 0 2px 10px #ffbdbd;
        }
        .span2 {
          background: #dcdee0;
        }
        .status {
          color: #808080;
          white-space: nowrap;
        }
      }
    }
    .coupon-title {
      margin-bottom: 14px;
      .span1 {
        font-size: 26px;
        font-weight: 600;
        color: #fa4b4b;
        margin-right: 12px;
        i {
          font-size: 42px;
        }
      }
      .span2 {
        font-size: 14px;
        padding: 2px 12px;
        background: #f8f8f8;
        color: #505050;
        border-radius: 13px;
        font-weight: bold;
      }
    }
    .desc {
      font-size: 14px;
      color: #505050;
      margin-bottom: 18px;
     // text-overflow: ellipsis;
      width: 250px;
     // white-space: nowrap;
     // overflow: hidden;
    }
    .date {
      font-size: 12px;
      color: #a6a6a6;
    }
  }
}
.empty{
    height: 260px;
    width: 1200px;
background-color: #fdfdfd;
border-radius: 10px;

  @include flex-c;
.empty-img{
  margin-right: 35px;
}
  .empty-con{
     @include flex-d-c;
    h5{
      font-size: 18px;
      color: #505050;
      margin-bottom: 22px;

    }
    p{
      font-size: 16px;
      color: #808080;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/get-coupon/index.vue